import { useState } from 'react';
import { COUNTRIES, findCountry } from '../utils/countries';

// Click-to-open dropdown with search. The selected country shows
// flag + name; the dropdown panel filters by name or ISO code.
export default function CountryPicker({ value, onChange, placeholder = 'Select country' }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const selected = findCountry(value);
  const filtered = q
    ? COUNTRIES.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()) || c.code.toLowerCase().includes(q.toLowerCase()))
    : COUNTRIES;

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          width: '100%',
          textAlign: 'left',
          padding: '12px 14px',
          background: 'var(--card)',
          border: '1px solid var(--line)',
          borderRadius: 12,
          color: selected ? 'var(--text)' : 'var(--muted)',
          display: 'flex', alignItems: 'center', gap: 10,
          fontWeight: 700
        }}
      >
        {selected ? <><span style={{ fontSize: 20 }}>{selected.flag}</span><span>{selected.name}</span></> : placeholder}
        <span style={{ marginLeft: 'auto', color: 'var(--muted)' }}>▾</span>
      </button>

      {open ? (
        <>
          <div
            onClick={() => setOpen(false)}
            style={{ position: 'fixed', inset: 0, zIndex: 110 }}
          />
          <div style={{
            position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 6,
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            borderRadius: 12,
            boxShadow: 'var(--shadow-card)',
            maxHeight: 320, overflowY: 'auto',
            zIndex: 120
          }}>
            <div style={{ position: 'sticky', top: 0, padding: 10, background: 'var(--panel)', borderBottom: '1px solid var(--line-soft)' }}>
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search country"
                autoFocus
              />
            </div>
            {filtered.map((c) => {
              const active = c.code === value;
              return (
                <button
                  key={c.code}
                  type="button"
                  onClick={() => { onChange?.(c.code); setOpen(false); setQ(''); }}
                  style={{
                    width: '100%', textAlign: 'left',
                    padding: '10px 14px',
                    display: 'flex', alignItems: 'center', gap: 10,
                    background: active ? 'rgba(255,62,127,.08)' : 'transparent',
                    color: active ? 'var(--text)' : 'var(--text-dim)',
                    fontWeight: 700, fontSize: 14
                  }}
                >
                  <span style={{ fontSize: 20 }}>{c.flag}</span>
                  <span style={{ flex: 1 }}>{c.name}</span>
                  <span className="muted" style={{ fontSize: 11 }}>{c.code}</span>
                </button>
              );
            })}
            {filtered.length === 0 ? <div className="muted" style={{ padding: 16, textAlign: 'center' }}>No matches</div> : null}
          </div>
        </>
      ) : null}
    </div>
  );
}
